import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../apiConfig';
import moment from 'moment';

const createQueryParams = (page, pageSize, filters) => {
  const params = new URLSearchParams();
  
  if (page) params.append('page', page);
  if (pageSize) params.append('page_size', pageSize);
  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params.append(key, filters[key]);
    });
  }

  return params.toString();
};

// export const fetchAllLoanOxyzo = createAsyncThunk(
//   'collection/fetchAllLoanOxyzo',
//   async ({ jwtBearer, page, pageSize, filters } = {}) => {
//     const queryParams = createQueryParams(page, pageSize, filters);
//     const response = await axios.get(`${BASE_URL}oxyzo/all/loan/data/${queryParams ? `?${queryParams}` : ''}`, {
//       headers: {
//         Authorization: `Bearer ${jwtBearer}`
//       }
//     });
//     return response.data;
//   }
// );


export const fetchAllLoanOxyzo = createAsyncThunk(
  'collection/fetchAllLoanOxyzo',
  async ({ jwtBearer, page, pageSize, filters } = {}, { rejectWithValue }) => {
    try {
      const queryParams = createQueryParams(page, pageSize, filters);
      const response = await axios.get(
        `${BASE_URL}oxyzo/all/loan/data/${queryParams ? `?${queryParams}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.reload();
      }
      console.error('Fetch error:', error);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);


export const fetchFilteredAllLoanOxyzo = createAsyncThunk(
  'collection/fetchFilteredAllLoanOxyzo',
  async ({ jwtBearer, filters } = {}) => {
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}oxyzo/all/loan/data/${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);


export const uploadAllLoanFile = createAsyncThunk(
  'upload/uploadAllLoanFile',
  async ({ file, uploadType }, { rejectWithValue }) => {
    if (!file) return rejectWithValue('Please select a file to upload!');
    if (!uploadType) return rejectWithValue('Please select an upload type!');

    const formData = new FormData();
    formData.append('file', file.originFileObj);

    try {
      const response = await axios.post(
        `${BASE_URL}oxyzo/upload/all/loan/data/?type=${uploadType}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'File upload failed!');
    }
  }
);


export const downloadAllLoanOxyzoReport = createAsyncThunk(
  'downloadAllLoanOxyzoReport',
  async ({ jwtBearer, startDate, endDate }, { rejectWithValue }) => {
    try {
      let fileName = `Oxyzo_All_loan${startDate || 'report'}`;

      if (startDate && endDate) {
        fileName = `Oxyzo_All_loan${startDate}_to_${endDate}.csv`;
      } else if (!startDate && !endDate) {
        fileName = `oxyzo_collection_report.csv`;
      }

      const response = await fetch(`${BASE_URL}oxyzo/report/download/`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${jwtBearer}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          start_date: startDate,
          end_date: endDate,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to generate report');
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;  
      link.click();

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading all loan report:', error);
      return rejectWithValue(error.message);
    }
  }
);

const collectionOxyzoSlice = createSlice({
  name: 'oxyzoAllLoan',
  initialState: {
    data: [],
    loading: false,
    error: null,
    totalCount: 0,

    filteredData: [],
    filteredLoading: false,
    filteredError: null,
    filteredTotalCount: 0,

      // Upload State
      uploadLoading: false,
      uploadError: null,
      uploadSuccess: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllLoanOxyzo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllLoanOxyzo.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.collection_data; 
        console.log("state.data--",state.data)
        state.totalCount = action.payload.data.total_collection_data; 
      })
      .addCase(fetchAllLoanOxyzo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchFilteredAllLoanOxyzo.pending, (state) => {
        state.filteredLoading = true;
        state.filteredError = null;
      })
      .addCase(fetchFilteredAllLoanOxyzo.fulfilled, (state, action) => {
        state.filteredLoading = false;
        state.filteredData = action.payload.data.collection_data;
        state.filteredTotalCount = action.payload.data.total_collection_data || 0; 
      })
      .addCase(fetchFilteredAllLoanOxyzo.rejected, (state, action) => {
        state.filteredLoading = false;
        state.filteredError = action.error.message;
      })

         // Upload Loan File
         .addCase(uploadAllLoanFile.pending, (state) => {
          state.uploadLoading = true;
          state.uploadError = null;
          state.uploadSuccess = null;
        })
        .addCase(uploadAllLoanFile.fulfilled, (state, action) => {
          state.uploadLoading = false;
          state.uploadSuccess = action.payload.message;
        })
        .addCase(uploadAllLoanFile.rejected, (state, action) => {
          state.uploadLoading = false;
          state.uploadError = action.payload;
        });
  }
});

export default collectionOxyzoSlice.reducer;
